const THEMEURL = window.drupalSettings ? window.drupalSettings.path.themeUrl : 'themes/custom/mx_aguas_firmes_theme';

export const DictionaryPage: any = {
    es: {
        allies: 'aliados',
        contact: 'contacto',
        gallery: 'galeria'
    },
    en: {
        allies: 'partners',
        contact: 'contact',
        gallery: 'gallery'
    }
}

export const emails = [
    "temp-mail.org",
    "correotemporal.org",
    "mohmal.com",
    "yopmail.com",
    "tempail.com",
    "emailondeck.com",
    "emailtemporalgratis.com",
    "crazymailing.com",
    "tempr.email",
    "bupmail.com",
    "guerrillamail.com",
    "temp-mail.io",
    "es.emailfake.com",
    "nowmymail.com",
    "10minutemail.net",
    "es.getairmail.com",
    "mailf5.com",
    "flashmail.it",
    "10minemail.com",
    "mailcatch.com",
    "temp-mails.com",
    "spambox.us",
    "mailnull.com",
    "incognitomail.com",
    "ssl.trashmail.net",
    "trashmail.net",
    "mailinator.com",
    "tempinbox.com",
    "filzmail.com",
    "dropmail.me",
    "spam4.me",
    "cs.email",
    "one-off.email",
    "throwawaymail.com",
    "emailtemporal.org",
    "maildrop.cc",
    "mailforspam.com",
    "trashmail.com",
    "teleworm.us",
    "superrito.com",
    "rhyta.com",
    "jourrapide.com",
    "gustr.com",
    "fleckens.hu",
    "einrot.com",
    "cuvox.de",
    "dayrep.com",
    "muyoc.com",
    "buxod.com",
    "pidox.org",
    "mecip.net",
    "pudxe.com",
    "xedmi.com",
    "ludxc.com",
    "juzab.com",
    "klepf.com",
    "matra.site",
    "bombamail.icu",
    "yermail.net",
    "totallynotfake.net",
    "techblast.ch",
    "spamthis.network",
    "spammy.host",
    "spammer.fail",
    "shadap.org",
    "pewpewpewpew.pw",
    "netcom.ws",
    "itcompu.com",
    "disposable.site",
    "deinbox.com",
    "sharklasers.com",
    "guerrillamailblock.com",
    "guerrillamail.org",
    "guerrillamail.net",
    "guerrillamail.de",
    "guerrillamail.biz",
    "grr.la",
    "netmail.tk",
    "laste.ml",
    "firste.ml",
    "zeroe.ml",
    "supere.ml",
    "emlhub.com",
    "emlpro.com",
    "emltmp.com",
    "yomail.info",
    "10mail.org",
    "wegwerfmail.org",
    "wegwerfmail.net",
    "wegwerfmail.de",
    "trashmail.me",
    "trashmail.io",
    "trashmail.at",
    "trash-mail.at",
    "rcpt.at",
    "proxymail.eu",
    "objectmail.com",
    "kurzepost.de",
    "damnthespam.com",
    "contbay.com",
    "0box.eu",
    "marmaryta.space",
    "5y5u.com",
    "58as.com",
    "firemailbox.club",
    "mozej.com",
    "mailna.co",
    "mailna.in",
    "mailna.me",
    "mohmal.im",
    "mohmal.in",
    "yopmail.fr",
    "yopmail.net",
    "cool.fr.nf",
    "jetable.fr.nf",
    "nospam.ze.tc",
    "nomail.xl.cx",
    "mega.zik.dj",
    "speed.1s.fr",
    "courriel.fr.nf",
    "moncourrier.fr.nf",
    "monemail.fr.nf",
    "monmail.fr.nf",
    "nedoz.com",
    "nmagazinec.com",
    "armyspy.com",
    "vmani.com",
    "discard.email",
    "discardmail.com",
    "discardmail.de",
    "spambog.com",
    "spambog.de",
    "spambog.ru",
    "0btcmail.pw",
    "815.ru",
    "knol-power.nl",
    "hartbot.de",
    "freundin.ru",
    "smashmail.de",
    "s0ny.net",
    "pecinan.net",
    "budaya-tionghoa.com",
    "lajoska.pe.hu",
    "1mail.x24hr.com",
    "from.onmypc.info",
    "now.mefound.com",
    "mowgli.jungleheart.com",
    "yourspamgoesto.space",
    "pecinan.org",
    "budayationghoa.com",
    "CR.cloudns.asia",
    "TLS.cloudns.asia",
    "MSFT.cloudns.asia",
    "B.cr.cloUdnS.asia",
    "ssl.tls.cloudns.ASIA",
    "sweetxxx.de",
    "DVD.dns-cloud.net",
    "DVD.dnsabr.com",
    "BD.dns-cloud.net",
    "YX.dns-cloud.net",
    "SHIT.dns-cloud.net",
    "SHIT.dnsabr.com",
    "eu.dns-cloud.net",
    "eu.dnsabr.com",
    "asia.dnsabr.com",
    "8.dnsabr.com",
    "pw.8.dnsabr.com",
    "mm.8.dnsabr.com",
    "23.8.dnsabr.com",
    "pecinan.com",
    "disposable-email.ml",
    "pw.epac.to",
    "postheo.de",
    "sexy.camdvr.org",
    "Disposable.ml",
    "888.dnS-clouD.NET",
    "adult-work.info",
    "casinokun.hu",
    "bangsat.in",
    "wallus.casinokun.hu",
    "trap-mail.de",
    "umailz.com",
    "panchoalts.com",
    "gmaile.design",
    "ersatzauto.ch",
    "tempes.gq",
    "cpmail.life",
    "tempemail.info",
    "coolmailcool.com",
    "kittenemail.com",
    "99email.xyz",
    "notmyemail.tech",
    "m.cloudns.cl",
    "twitter-sign-in.cf",
    "anonymized.org",
    "you.has.dating",
    "ketoblazepro.com",
    "kost.party",
    "0hio0ak.com",
    "4dentalsolutions.com",
    "t.woeishyang.com",
    "ondemandemail.top",
    "kittenemail.xyz",
    "blackturtle.xyz",
    "y.x.ssl.cloudns.asia",
    "geneseeit.com",
    "mailg.ml",
    "media.motornation.buzz",
    "sage.speedfocus.biz",
    "badlion.co.uk",
    "safeemail.xyz",
    "virtual-generations.com",
    "new-york.host",
    "mrdeeps.ml",
    "kitela.work",
    "fouadps.cf",
    "megacorp.work",
    "fake-wegwerf.email",
    "tigytech.com",
    "historictheology.com",
    "ma.567map.xyz",
    "hotmailproduct.com",
    "maxsize.online",
    "happyfreshdrink.com",
    "denomla.com",
    "pansamantala.poistaa.com",
    "sahaltastari.sytes.net",
    "cecep.ddnsking.com",
    "fadilmalik.ddnsking.com",
    "csingi.sytes.net",
    "richmail.ga",
    "tikmail.gq",
    "bupkiss.ml",
    "guerrillamail.info",
    "pokemail.net",
    "myinbox.icu",
    "just4fun.me",
    "inscriptio.in",
    "cloud-mail.top",
    "safemail.icu",
    "montokop.pw",
    "tempamailbox.info",
    "blogtron.com",
    "atanetorg.org",
    "aristockphoto.com",
    "jomcs.com",
    "kukuka.org",
    "gothill.com",
    "mixely.com",
    "marsoasis.org",
    "walmarteshop.com",
    "outlandlabs.com",
    "comectrix.com",
    "buymondo.com",
    "eventao.com",
    "louieliu.com",
    "mymailnow.xyz",
    "cuoly.com",
    "getnada.com",
    "abyssmail.com",
    "boximail.com",
    "clrmail.com",
    "dropjar.com",
    "getairmail.com",
    "givmail.com",
    "inboxbear.com",
    "robot-mail.com",
    "tafmail.com",
    "vomoto.com",
    "zetmail.com",
];

export const draws = [
    {
        "_id": "6227bf562fa91a6d69057516",
        "category": 'Infantil',
        "image": `/${THEMEURL}/sources/dist/assets/images/gallery/af-draw.jpg`,
        "name": "Lowe Barrett",
        "location": "Apan",
        "votes": "000",
    },
    {
        "_id": "6227bf561955163d60ee125a",
        "category": 'Junior',
        "image": `/${THEMEURL}/sources/dist/assets/images/gallery/af-draw2.jpg`,
        "name": "Ivy Stanley",
        "location": "Calera",
        "votes": "000",
    },
    {
        "_id": "6227bf565d6e18e0fe560d36",
        "category": 'Junior',
        "image": `/${THEMEURL}/sources/dist/assets/images/gallery/af-draw2.jpg`,
        "name": "Tabatha Glass",
        "location": "Apan",
        "votes": "000",
    },
    {
        "_id": "6227bf566bd1b8365a3296f4",
        "category": 'Infantil',
        "image": `/${THEMEURL}/sources/dist/assets/images/gallery/af-draw.jpg`,
        "name": "Regina Golden",
        "location": "Apan",
        "votes": "000",
    },
    {
        "_id": "6227bf569252f02077ed6e87",
        "category": 'Junior',
        "image": `/${THEMEURL}/sources/dist/assets/images/gallery/af-draw2.jpg`,
        "name": "Talley Christian",
        "location": "Calera",
        "votes": "000",
    },
    {
        "_id": "6227bf5670db1bfcabdccb6f",
        "category": 'Infantil',
        "image": `/${THEMEURL}/sources/dist/assets/images/gallery/af-draw.jpg`,
        "name": "Bettye Cline",
        "location": "Apan",
        "votes": "000",
    }
]

export const rankingApan = [

    {
        "_id": "6230a16642c5c9c0354ef443",
        "image": "/${THEMEURL}/sources/dist/assets/images/gallery/af-draw2.jpg",
        "age": 32,
        "position": 25,
        "town": "Apan",
        "category": "Infantil",
        "name": "Reilly Griffin",
        "votes": "000",
    },
    {
        "_id": "6230a16615bfa7af07ee34f6",
        "image": "/${THEMEURL}/sources/dist/assets/images/gallery/af-draw2.jpg",
        "age": 37,
        "position": 37,
        "town": "Apan",
        "category": "Infantil",
        "name": "Reeves Page",
        "votes": "000",
    },
    {
        "_id": "6230a1665989151c86c41db2",
        "image": "/${THEMEURL}/sources/dist/assets/images/gallery/af-draw2.jpg",
        "age": 31,
        "position": 40,
        "town": "Apan",
        "category": "Infantil",
        "name": "April Skinner",
        "votes": "000",
    },
    {
        "_id": "6230a166cb9b72099e07a2b5",
        "image": "/${THEMEURL}/sources/dist/assets/images/gallery/af-draw2.jpg",
        "age": 38,
        "position": 30,
        "town": "Apan",
        "category": "Infantil",
        "name": "Meyer Nash",
        "votes": "000",
    },
    {
        "_id": "6230a16605065728f67c2ffa",
        "image": "/${THEMEURL}/sources/dist/assets/images/gallery/af-draw2.jpg",
        "age": 33,
        "position": 26,
        "town": "Apan",
        "category": "Infantil",
        "name": "Rutledge Perez",
        "votes": "000",
    },
    {
        "_id": "6230a166888d6279ee6897e9",
        "image": "/${THEMEURL}/sources/dist/assets/images/gallery/af-draw2.jpg",
        "age": 20,
        "position": 30,
        "town": "Apan",
        "category": "Infantil",
        "name": "Black King",
        "votes": "000",
    },
    {
        "_id": "6230a1663586a2c225026461",
        "image": "/${THEMEURL}/sources/dist/assets/images/gallery/af-draw2.jpg",
        "age": 28,
        "position": 27,
        "town": "Apan",
        "category": "Infantil",
        "name": "Mai Carroll",
        "votes": "000",
    },
    {
        "_id": "6230a166a080b0928f9a22e2",
        "image": "/${THEMEURL}/sources/dist/assets/images/gallery/af-draw2.jpg",
        "age": 26,
        "position": 31,
        "town": "Apan",
        "category": "Infantil",
        "name": "Willie Spears",
        "votes": "000",
    },
    {
        "_id": "6230a16617308e1bcb8e7612",
        "image": "/${THEMEURL}/sources/dist/assets/images/gallery/af-draw2.jpg",
        "age": 36,
        "position": 39,
        "town": "Apan",
        "category": "Infantil",
        "name": "Clarice Byers",
        "votes": "000",
    },
    {
        "_id": "6230a16667cd90f0a671004a",
        "image": "/${THEMEURL}/sources/dist/assets/images/gallery/af-draw2.jpg",
        "age": 37,
        "position": 39,
        "town": "Apan",
        "category": "Infantil",
        "name": "Savannah Mcgee",
        "votes": "000",
    },
    {
        "_id": "6230a166f9902a8a66db04d1",
        "image": "/${THEMEURL}/sources/dist/assets/images/gallery/af-draw2.jpg",
        "age": 27,
        "position": 20,
        "town": "Apan",
        "category": "Infantil",
        "name": "Meredith Davis",
        "votes": "000",
    }
]

export const rankingApan2 = [

    {
        "_id": "6230a1667d90ac5a6e28a5ea",
        "image": "/${THEMEURL}/sources/dist/assets/images/gallery/af-draw2.jpg",
        "age": 26,
        "position": 20,
        "town": "Apan",
        "category": "Junior",
        "name": "Mccray Duran",
        "votes": "000",
    },
    {
        "_id": "6230a166099770d7f3b07453",
        "image": "/${THEMEURL}/sources/dist/assets/images/gallery/af-draw2.jpg",
        "age": 24,
        "position": 27,
        "town": "Apan",
        "category": "Junior",
        "name": "Bowers Cunningham",
        "votes": "000",
    },
    {
        "_id": "6230a1663042fbb6585e23df",
        "image": "/${THEMEURL}/sources/dist/assets/images/gallery/af-draw2.jpg",
        "age": 32,
        "position": 28,
        "town": "Apan",
        "category": "Junior",
        "name": "Thornton Parks",
        "votes": "000",
    },
    {
        "_id": "6230a16640cdb04546bba202",
        "image": "/${THEMEURL}/sources/dist/assets/images/gallery/af-draw2.jpg",
        "age": 33,
        "position": 32,
        "town": "Apan",
        "category": "Junior",
        "name": "Castaneda Terry",
        "votes": "000",
    },
    {
        "_id": "6230a16649ec23a32ec83293",
        "image": "/${THEMEURL}/sources/dist/assets/images/gallery/af-draw2.jpg",
        "age": 30,
        "position": 22,
        "town": "Apan",
        "category": "Junior",
        "name": "Annie Mccray",
        "votes": "000",
    },
    {
        "_id": "6230a16611f682b8f05d09cd",
        "image": "/${THEMEURL}/sources/dist/assets/images/gallery/af-draw2.jpg",
        "age": 22,
        "position": 32,
        "town": "Apan",
        "category": "Junior",
        "name": "Trevino Velasquez",
        "votes": "000",
    },
]

export const rankingCalera = [
    {
        "_id": "6230a166ca6e3702303229d3",
        "image": "/${THEMEURL}/sources/dist/assets/images/gallery/af-draw2.jpg",
        "age": 28,
        "position": 21,
        "town": "Calera",
        "category": "Infantil",
        "name": "Annabelle Compton",
        "votes": "000",
    },
    {
        "_id": "6230a1668f85529c2bc46bc5",
        "image": "/${THEMEURL}/sources/dist/assets/images/gallery/af-draw2.jpg",
        "age": 31,
        "position": 23,
        "town": "Calera",
        "category": "Infantil",
        "name": "Horton Salas",
        "votes": "000",
    },
    {
        "_id": "6230a1669d7492257f81bf70",
        "image": "/${THEMEURL}/sources/dist/assets/images/gallery/af-draw2.jpg",
        "age": 37,
        "position": 30,
        "town": "Calera",
        "category": "Infantil",
        "name": "Rowena Morris",
        "votes": "000",
    }
]

export const rankingCalera2 = [
    {
        "_id": "6230a166e94fd57a0cc6b2c4",
        "image": "/${THEMEURL}/sources/dist/assets/images/gallery/af-draw2.jpg",
        "age": 40,
        "position": 35,
        "town": "Calera",
        "category": "Junior",
        "name": "Jordan Turner",
        "votes": "000",
    },
    {
        "_id": "6230a16649badb1ca93f6f94",
        "image": "/${THEMEURL}/sources/dist/assets/images/gallery/af-draw2.jpg",
        "age": 26,
        "position": 40,
        "town": "Calera",
        "category": "Junior",
        "name": "Diaz Mcclain",
        "votes": "000",
    },
    {
        "_id": "6230a16644c0883091ac2553",
        "image": "/${THEMEURL}/sources/dist/assets/images/gallery/af-draw2.jpg",
        "age": 23,
        "position": 38,
        "town": "Calera",
        "category": "Junior",
        "name": "Lorraine Fischer",
        "votes": "000",
    },
    {
        "_id": "6230a1662cf6fbab41775652",
        "image": "/${THEMEURL}/sources/dist/assets/images/gallery/af-draw2.jpg",
        "age": 28,
        "position": 24,
        "town": "Calera",
        "category": "Junior",
        "name": "Tonya Lee",
        "votes": "000",
    },
    {
        "_id": "6230a166d68f37ed6d06fd73",
        "image": "/${THEMEURL}/sources/dist/assets/images/gallery/af-draw2.jpg",
        "age": 28,
        "position": 39,
        "town": "Calera",
        "category": "Junior",
        "name": "Pratt Alexander",
        "votes": "000",
    }
]

export const towns = [
    {
        title: "Apan",
        infantil: {
            title: "Infantil: 6 - 8 años",
            list: [...rankingApan]
        },
        juvenil: {
            title: "Junior: 9 - 11 años",
            list: [...rankingApan2]
        }
    },
    {
        title: "Calera",
        infantil: {
            title: "Infantil: 6 - 8 años",
            list: [...rankingCalera]
        },
        juvenil: {
            title: "Junior: 9 - 11 años",
            list: [...rankingCalera2]
        }
    }
]